import * as React from 'react'
import { connect } from 'react-redux'
import { confirmDeleteContact } from 'features/Contacts/Contacts.actions'
import { showContactTriggerFlowModal } from 'features/Contacts/ContactTriggerFlowModal'
import { Contact } from './Contact'

export interface IContactPageContainerProps {
  params: {
    contactId: string
  }
}

const stateToProps = ({}, { params: { contactId } }: IContactPageContainerProps) => {
  return {
    contactId,
  }
}

export const dispatchToProps = {
  confirmDeleteContact,
  showContactTriggerFlowModal,
}

export const ContactPage = connect(stateToProps, dispatchToProps)(Contact) as React.SFC<
  IContactPageContainerProps
>



// WEBPACK FOOTER //
// src/pages/Contact/Contact.container.ts